<template>
    <!-- 帖子详情页专属弹窗 -->
    <div v-if="isOpen">
        <div class="f-topic-confirm-box">
            <div class="f-topic-confirm-box-close" @click="cancel"></div>

            <div class="f-topic-confirm-box-content">
                <div v-if="title.length"
                    class="f-topic-confirm-box-content-title">
                    <img :src="infoIcon"
                        class="f-topic-confirm-box-content-title-icon">
                    <span class="f-topic-confirm-box-content-title-word">
                        {{title}}
                    </span>
                </div>
                <div class="f-topic-confirm-box-content-tip"
                    v-if="tip.length">{{tip}}</div>
            </div>
            
            <div class="f-topic-confirm-box-footer">
                <span class="f-topic-confirm-box-footer-ok"
                    @click="ok">{{confirmTip}}</span>
                <span class="f-topic-confirm-box-footer-cancel"
                    @click="cancel">取消</span>
            </div>
        </div>

        <div class="f-topic-confirm-box-overlay" @click.self="cancel"></div>
    </div>
</template>

<style lang="less">
    @import '../../assets/less/components/confirm-box.less';
</style>

<script>
import {notAllowScroll, allowScroll} from '@/utils/decorate/scroll';

export default {
    data() {
        return {
            infoIcon: require('../../assets/images/icon-info.png')
        };
    },
    watch: {
        isOpen: function (val) {
            if (val) {
                notAllowScroll();
            }
            else {
                allowScroll();
            }
        }
    },
    props: {
        isOpen: {
            'type': Boolean,
            'default': false
        },
        title: {
            'type': String,
            'default': ''
        },
        tip: {
            'type': String,
            'default': ''
        },
        btnTip: {
            'type': String,
            'default': ''
        }
    },
    computed: {
        confirmTip: {
            get() {
                return this.btnTip.length ? this.btnTip : '确定';
            }
        }
    },
    methods: {
        cancel() {
            this.$emit('operate', 'cancel');
        },
        ok() {
            this.$emit('operate', 'ok');
        }
    }
};
</script>
